<template>
  <main class="relative overflow-hidden">
    <div class="absolute inset-0 image-wrapper">
      <slot name="image"></slot>
      <div class="absolute inset-0 bg-accent opacity-100 mix-blend-multiply" />
    </div>
    <div class="max-w-7xl mx-auto sm:p-6">
      <div class="relative py-16 sm:py-24 lg:py-32">
        <h1
          class="
            mt-28
            text-4xl
            font-extrabold
            tracking-tight
            sm:text-5xl
            lg:text-6xl
            text-center
            sm:text-left
          "
        >
          <slot name="title"></slot>
        </h1>

        <div class="mt-20">
          <div class="grid place-items-center sm:place-items-start">
            <Button path="/contact" theme="light">Contact Us</Button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Button from "@/components/base/Button.vue";
export default {
  components: { Button },
};
</script>

<style>
.image-wrapper img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
</style>
